export default [
  {
    path: '/category-list',
    name: 'category-list',
    component: () => import('@/pages/category-list/index.vue'),
    meta: {
      title: '类目列表',
      telescope: 'zyjk-page-medicinesearch-alllist',
      h5Nav: true,
    },
  },
  {
    path: '/drug-list',
    name: 'drug-list',
    component: () => import('@/pages/drug-list/index.vue'),
    meta: {
      title: '药品列表',
      h5Nav: true,
    },
  },
  {
    path: '/guide-home',
    name: 'guide-home',
    component: () => import('@/pages/guide-home/index.vue'),
    meta: {
      title: '用药查询',
      h5Nav: true,
      telescope: 'zyjk-page-medicinesearch',
    },
  },
  {
    path: '/audit-doctor-list',
    name: 'audit-doctor-list',
    component: () => import('@/pages/audit-doctor-list/index.vue'),
    meta: {
      title: '已审核认证专家',
    },
  },
  {
    path: '/audit-view',
    name: 'audit-view',
    component: () => import('@/pages/audit-view/index.vue'),
    meta: {
      title: '审核任务',
      telescope: 'zyys-page-index-TaskCenter-detail',
    },
  },
  {
    path: `/tag-list`,
    name: 'tag-list',
    component: () => import(`@/pages/tag-list/index.vue`),
    meta: {
      title: '内容列表',
      telescope: '',
    },
  },
  {
    path: `/article-list`,
    name: 'article-list',
    component: () => import(`@/pages/article-list/index.vue`),
    meta: {
      title: '每日推荐',
      telescope: '',
    },
  },
  {
    path: `/article-detail`,
    name: 'article-detail',
    component: () => import(`@/pages/article-detail/index.vue`),
    meta: {
      title: '内容加载中...',
      // h5Nav: true, // 不能用 有iframe嵌套的 需要单独处理
    },
  },
  {
    path: `/doctor-article`,
    name: 'doctor-article',
    component: () => import(`@/pages/doctor-article/index.vue`),
    meta: {
      title: '文章详情',
      telescope: 'zyys-page-content-list-details',
    },
  },
  {
    path: `/doctor-article-list/:authorId`,
    name: 'doctor-article-list',
    component: () => import(`@/pages/doctor-article-list/index.vue`),
    meta: {
      title: '文章列表',
    },
  },
  {
    path: '/',
    redirect: '/article-list'
  },
];
